import React, { useEffect, useRef, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
// import banner1 from '../../../../assests/imgs/new-banner1.svg'
// import banner2 from '../../../../assests/imgs/new-banner2.svg'
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

import banner1 from '../../../../assests/imgs/new-banner-bg.png'
import banner2 from '../../../../assests/imgs/new-banner2.svg'
import icon1 from '../../../../assests/imgs/icon1.svg'
import icon2 from '../../../../assests/imgs/icon2.svg'
import icon3 from '../../../../assests/imgs/icon3.svg'
import icon4 from '../../../../assests/imgs/icon4.svg'
import icon5 from '../../../../assests/imgs/icon5.svg'
import icon6 from '../../../../assests/imgs/icon6.svg'
import icon7 from '../../../../assests/imgs/icon7.svg'
import icon8 from '../../../../assests/imgs/icon8.svg'
import icon9 from '../../../../assests/imgs/icon9.svg'
import new1 from '../../../../assests/imgs/new-1.svg'
import new2 from '../../../../assests/imgs/new-2.svg'
import new3 from '../../../../assests/imgs/new-3.svg'
import new4 from '../../../../assests/imgs/new-4.svg'
import new5 from '../../../../assests/imgs/new-5.svg'
import new6 from '../../../../assests/imgs/new-6.svg'
import new7 from '../../../../assests/imgs/new-7.svg'
import new8 from '../../../../assests/imgs/new-8.svg'
import new9 from '../../../../assests/imgs/new-9.svg'


export default function WelcometoUrxprt() {
  const path = "Assets/scss/homepage.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const { setOTSroute } = useRouteBaseStateContext();

  const NavigateToCreate = (path, thetype) => {
    navigate(`/${lan}/${path}`, { state: { theType: thetype ?? "" } });
  };

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const handleMobileNavigation = (path, options = {}) => {

    navigate(path, options);
  };
  return (
    <div className="welcomepage">
      <div className="welcome-first col-lg-6 col-md-11 mx-auto pt-0">
        <h6>
          👋 Welcome to Urxprt, {profile.first_name} {profile.last_name}
        </h6>
        <h1>Grow your freelancing career with Urxprt</h1>
      </div>
      <div className="col-lg-10 col-md-11 mx-auto expert-1">
        <div className="row it-row">
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Find Post & Browse Projects (PBP)</h5>
              <p>
                Browse a variety of projects, filter by needs, and find the right match.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=1`)}
              >
                Find Post & Browse Projects (PBP)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Bid in Win business Opportunities (WBO)</h5>
              <p>
                Compete in contests by submitting your best solutions and win exciting business opportunities.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=2`)}
              >
                Explore Win business Opportunities (WBO)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Find Part time Job (PTJ)</h5>
              <p>
                Find trusted part-time opportunities suited for students, freelancers, and professionals seeking flexible work options.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchall?type=3`)}
              >
                Find Part time Job (PTJ)
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>One Time Services (OTS)</h5>
              <p>
                Get instant solutions through on-demand, one-time expert services.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchpackaged`)}
              >
                Create OTS
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Turn Assets to Income (TAI)</h5>
              <p>
                Generate income by sharing or renting out your valuable assets.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchrentproducts`);
                  setOTSroute("RentalProducts");
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Bid in Buy & Sell with Auction (BSA)</h5>
              <p>
                Place your bids, win deals, and trade seamlessly with auctions.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchauction`);
                  setOTSroute("Auctionitem");
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Buy & Sell with Market (BSM)</h5>
              <p>
                Explore a wide range of items, list your products, and trade instantly.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchbuyproducts`);
                }}
              >
                Explore buy & sell
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Merger and Acquisition (MAS)</h5>
              <p>
                Discover business merger and acquisition opportunities to expand, collaborate, or invest in growing ventures.
              </p>
              <a
                className="btn"
                onClick={() => {
                  navigate(`/${lan}/searchmergersacquisitions`);
                }}
              >
                Let’s get started
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="homepage-second">
        <div className="upgarde-img">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/homepage/home-banner.png`}
            className="banner w-100"
            alt=""
          />
          <div className="banner-content">
            <h2 className="font-42">
              Upgrade membership <span> & start creating one time </span>
              services (OTS)
            </h2>
            <p>
              Transform your skills into on-demand one-time services. Upgrade today and start monetizing your expertise.
            </p>
            <button
              className="btn"
              onClick={() => navigate(`/${lan}/account/upgrademembership`)}
            >
              View Plans
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </button>
          </div>
        </div>
      </div> */}
      <div className="banner-wrapper">
        <button ref={prevRef} className="custom-arrow custom-prev">
          <i className="fa-solid fa-angle-left"></i>
        </button>

        <button ref={nextRef} className="custom-arrow custom-next">
          <i className="fa-solid fa-angle-right"></i>
        </button>
        <div className="homepage-second">
          <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            loop
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000000 }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                Navigation: false,
              },
              768: {
                Navigation: false,
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
            }}

          >
            <SwiperSlide>
              <div className="new-banner-sec newbanner1"
              >
                <div className="row align-items-center">
                  <div className="col-lg-5">
                    <h2>Find top projects, contest  Job opportunities & More</h2>

                  </div>
                  <div className="col-lg-7">
                    <div className="row banner-inner-row">
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchdownloadcv`)}>
                          <img src={icon1} alt="" />
                          <p>Full Time Job (FTJ) </p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchall?type=3`)}>
                          <img src={icon2} alt="" />
                          <p>Part Time Job (PTJ)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchpackaged`)}>
                          <img src={icon3} alt="" />
                          <p>One Time Services (OTS)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung ?? "en"}/searchall?type=1`)}>
                          <img src={icon4} alt="" />
                          <p>Post & Browse Projects (PBP)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung ?? "en"}/searchall?type=2`)}>
                          <img src={icon5} alt="" />
                          <p>Win business Opportunities (WBO)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchmergersacquisitions`)}>
                          <img src={icon6} alt="" />
                          <p>Mergers & Acquisitions (MAS)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchbuyproducts`)}>
                          <img src={icon7} alt="" />
                          <p>Buy & Sell with Market (BSM)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchauction`)}>
                          <img src={icon8} alt="" />
                          <p>Buy & Sell with Auctions (BSA)</p>
                        </div>
                      </div>
                      <div className="col-md-4 text-center">
                        <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchrentproducts`)}>
                          <img src={icon9} alt="" />
                          <p>Turn  Assets to Income (TAI)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="col-md-12 newbanner2">
                <div className="row banner-inner-row">
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchdownloadcv`)}>
                      <img src={new1} alt="" />
                      <p>Full Time Job (FTJ) </p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchall?type=3`)}>
                      <img src={new2} alt="" />
                      <p>Part Time Job (PTJ)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchpackaged`)}>
                      <img src={new3} alt="" />
                      <p>One Time Services (OTS)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung ?? "en"}/searchall?type=1`)}>
                      <img src={new4} alt="" />
                      <p>Post & Browse Projects (PBP)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung ?? "en"}/searchall?type=2`)}>
                      <img src={new5} alt="" />
                      <p>Win business Opportunities (WBO)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchmergersacquisitions`)}>
                      <img src={new6} alt="" />
                      <p>Mergers & Acquisitions (MAS)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchbuyproducts`)}>
                      <img src={new7} alt="" />
                      <p>Buy & Sell with Market (BSM)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchauction`)}>
                      <img src={new8} alt="" />
                      <p>Buy & Sell with Auctions (BSA)</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center">
                    <div style={{ cursor: 'pointer' }} onClick={() => handleMobileNavigation(`/${laung}/searchrentproducts`)}>
                      <img src={new9} alt="" />
                      <p>Turn  Assets to Income (TAI)</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="col-lg-10 col-md-11 mx-auto expert-1 industries">
        <div className="welcome-first col-lg-8 mx-auto ">
          <h1>Get your work done with industries top experts</h1>
        </div>
        <div className="row it-row">
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Post a Part time Job (PTJ)</h5>
              <p>
                Create part-time job posts and find applicants quickly.
              </p>
              <a
                className="btn"
                onClick={() => NavigateToCreate("createpost", 3)}
              >
                Create a post
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Buy one time service (OTS)</h5>
              <p>
                Get instant solutions through on-demand, one-time expert services.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/searchpackaged`)}
              >
                Explore Services
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="it-dev">
              <h5>Hire Experts</h5>
              <p>
                Hire qualified experts to get your tasks and projects done efficiently.
              </p>
              <a
                className="btn"
                onClick={() => navigate(`/${lan}/hireexpertsmainpage`)}
              >
                Find Experts
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {
        (profile?.role_type == 3 || profile?.role_type == 4) ? <></> :
          <div className="container-fluid user-sec">
            <div className="col-lg-10 mx-auto">
              <div className="row">
                <div className="col-md-6">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/expert.png`}
                    className="w-100"
                    alt=""
                  />
                </div>
                <div className="col-md-6">
                  <h6>Tailored solution for enterprises</h6>
                  <h2 className="font-42">
                    List your company, work and manage projects seamlessly on Urxprt
                  </h2>
                  <ul>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      List your brand on Urxprt
                    </li>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      Hire and manage experts on urxprt
                    </li>
                    <li>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                        alt=""
                      />
                      Task and billing management
                    </li>
                  </ul>
                  <button
                    className="btn"
                    onClick={() => navigate(`/${lan}/registration`)}
                  >
                    Register as company
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
      }
      {/* <div className="col-lg-10 mx-auto bxp-section">
        <div className="bxp-head">
          <h3 className="font-42">Browse One time services (OTS)</h3>
          <button
            className="btn"
            onClick={() => navigate(`/${lan}/account/upgrademembership`)}
          >
            View all
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
              alt=""
            />
          </button>
        </div>
        <div className="row bxp-mobile-row">
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>SAR 30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-2.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>SAR 30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-3.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>SAR 30</h6>
          </div>
          <div className="col-md-3 bxp-img col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-4.png`}
              className="w-100"
              alt=""
            />
            <p>Content writing and SEO</p>
            <h6>SAR 30</h6>
          </div>
        </div>
      </div> */}
    </div>
  );
}
